import api from '../lib/api';

const dashboardService = {
  getStats: (timeRange) => {
    const query = timeRange ? `?timeRange=${timeRange}` : '';
    return api.get(`/dashboard/stats${query}`);
  },
  getCircleDistribution: () => api.get('/dashboard/circle-distribution'),
  getCollaborations: () => api.get('/dashboard/collaborations'),
};

export default dashboardService;
